import Importacao from './componentes/Importacao.vue';
import ImportacaoLista from './componentes/Lista.vue';
import ImportacaoRelatorio from './componentes/Relatorio.vue';

export default {
  path: 'importacao',
  component: Importacao,
  meta: { auth: true },
  children: [
    {
      path: 'importacao',
      component: ImportacaoLista,
      name: 'compra.importacao',
    },
    {
      path: ':id/relatorio',
      component: ImportacaoRelatorio,
      name: 'importacao.relatorio'
    },
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/importacao/rotas.js